import { ref } from "vue";

import type { ITransaction } from "@/utils/types";
import WebSocketClient from "@/libs/WebSocketClient";
import { useQueryClient } from "@tanstack/vue-query";

let initialized = false;
let unsubscribeLatestTransactions: (() => void) | null = null;

const latestTransactions = ref<ITransaction[]>([]);

export function useLatestTransactions() {
  const queryClient = useQueryClient();

  if (!initialized) {
    initialized = true;
    unsubscribeLatestTransactions = WebSocketClient.subscribeForTransactions(
      (payload: any) => {
        const pages = [10, 20, 50, 100];
        pages.forEach((page) => {
          queryClient.setQueryData(
            [
              "TransactionsService.listTransactions",
              payload.token.sale_address,
              page,
              1,
            ],
            (oldData: any) => {
              return {
                ...oldData,
                meta: {
                  ...(oldData?.meta || {}),
                  totalItems: (oldData?.meta?.totalItems || 0) + 1,
                },
                items: [
                  payload.data,
                  ...(oldData?.items || []).slice(0, page - 1),
                ],
              };
            }
          );
        });

        // When latestTransaction is more than 50, remove first 20
        if (latestTransactions.value.length > 50) {
          latestTransactions.value = latestTransactions.value.slice(20);
        }
        latestTransactions.value.push({
          token: payload.token,
          ...payload.data,
        });
      }
    );
  }

  return {
    latestTransactions,
    unsubscribeLatestTransactions,
  };
}
